<template>
<!-- 友情链接 -->
    <div class="links">
        <div class="links_title">
            友情链接
        </div>

        <div class="links_list">
            <div class="links_item hvr-float" v-for="(item, index) in list" :key="index">
                <a :href="item.linkUrl" target="_blank">
                    {{ item.linkName }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                list: [
                    "中国政府网","中国政府网","中国政府网","中国政府网","中国政府网","中国政府网","中国政府网","中国政府网","中国政府网",
                    "中国政府网","中国政府网","中国政府网","中国政府网","中国政府网","中国政府网","中国政府网","中国政府网","中国政府网","中国政府网",
                    "中国政府网","中国政府网","中国政府网","中国政府网","中国政府网",
                ],
            }
        },
        mounted () {
            this.getLinkList();
        },
        methods: {
            // 获取友情链接
            async getLinkList() {
                let res = await this.$axios.post("/lencon/pc/index/link")
                if ( res.data.code == 1 ) {
                    this.list = res.data.data 
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.links {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    box-sizing: border-box;
    .links_title {
        font-size: 24px;
        color: #2767c4 ;
        padding: 10px 0;
        border-bottom: 1px solid #2767c4 ;
        font-weight: bold;
    }
    .links_list {
        padding: 20px 0;
        display: flex;
        flex-wrap: wrap;
        background: rgba(245,245,245,0.48);
        margin: 20px 0;
        .links_item {
            width: 150px;
            margin: 10px;
            font-size: 16px;
            a {
                color: #000;
            }
        }
    }
}
</style>